import { OrderStatus } from '@dss-libs/shared/type/common-types';

export const ORDER_STATISTICS_STATUSES = [
  OrderStatus.Cancelled,
  OrderStatus.Completed,
  OrderStatus.InProgress,
  OrderStatus.Expired,
  OrderStatus.Declined,
];

export const CLOSED_ORDER_STATUSES: OrderStatus[] = [OrderStatus.Cancelled, OrderStatus.Expired, OrderStatus.Declined];
